import { render, staticRenderFns } from "./TheTab.vue?vue&type=template&id=11fa74a2&scoped=true&"
import script from "./TheTab.vue?vue&type=script&lang=js&"
export * from "./TheTab.vue?vue&type=script&lang=js&"
import style0 from "./TheTab.vue?vue&type=style&index=0&id=11fa74a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fa74a2",
  null
  
)

export default component.exports